<div class="header__nav">
    <div class="nav-user">
      <div class="nav-user__container">
        <button class="nav-user__button">
            <div class="nav-user__icon">
              <ion-icon name="person-circle-sharp" class="icon"></ion-icon>
            </div>
        </button>
        <div class="nav-user__dropdown">
            <a href="#" class="nav-user__dropdown__link" (click)="goToJiraConfig($event)">{{ 'JIRA_CONFIG.MENU_LINK' | translate }}</a>
            <a href="#" class="nav-user__dropdown__link" (click)="closeSession()">Cerrar Sesión</a>
        </div>
      </div>
    </div>
  </div><!-- end of header__nav -->
